import {
    Injectable
} from '@angular/core';

import { Observable } from 'rxjs';
import {filter, take} from 'rxjs/operators';

import { NgxPrinterService } from 'ngx-printer';

@Injectable()
export class PrintService {
    constructor(
        private printerService: NgxPrinterService,
    ) {}

    public print(element: HTMLElement): Observable<boolean> {
        this.printerService.printHTMLElement(element);
        return this.printerService.$printWindowOpen.pipe(
            take(1),
            filter(isOpen => !isOpen)
        );
    }

}
